import { StyleSheet } from "@react-pdf/renderer";

import "../fonts";

export const colors = {
  text: "#1a1a1a",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  background: "#ffffff",
  warning: "#f69a0e",
};

export const PAGE_PADDING_HORIZONTAL = 48;
export const PAGE_PADDING_VERTICAL = 40;

// A4 page height in points per orientation
export const A4_PAGE_HEIGHT = { portrait: 841.89, landscape: 595.28 };

// Line charts are capped to this share of the page's content height so the
// summary always has room to start on the same page
const LINE_CHART_MAX_HEIGHT_RATIO = 0.6;

export const getLineChartMaxHeight = (orientation: "portrait" | "landscape") =>
  (A4_PAGE_HEIGHT[orientation] - PAGE_PADDING_VERTICAL * 2) *
  LINE_CHART_MAX_HEIGHT_RATIO;

export const pageStyles = StyleSheet.create({
  page: {
    fontFamily: "NotoSansJP",
    backgroundColor: colors.background,
    paddingTop: PAGE_PADDING_VERTICAL,
    paddingBottom: PAGE_PADDING_VERTICAL,
    paddingHorizontal: PAGE_PADDING_HORIZONTAL,
  },
});

export const sectionStyles = StyleSheet.create({
  container: {
    maxHeight: "100%",
    flex: 1,
    display: "flex",
    gap: 12,
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    color: colors.text,
  },
  summaryTextContainer: {},
  summaryText: {
    fontSize: 10,
    fontWeight: 400,
    color: colors.text,
  },
  noData: {
    fontSize: 10,
    fontWeight: 400,
    color: colors.warning,
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  // Sized to the chart rather than filling the page, so the summary sits
  // directly below it
  chartImageContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  lineChartImage: {
    width: "100%",
    objectFit: "contain",
  },
  chartImage: {
    objectFit: "contain",
  },
  subTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: colors.text,
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  listItem: {
    display: "flex",
    flexDirection: "row",
    gap: 6,
  },
  listBullet: {
    fontSize: 10,
    fontWeight: 400,
    color: colors.text,
  },
  listItemText: {
    flex: 1,
    fontSize: 10,
    fontWeight: 400,
    color: colors.text,
  },
  numberedListItem: {
    display: "flex",
    flexDirection: "row",
    gap: 6,
    width: "100%",
  },
  listNumberContainer: {},
  listNumber: {
    fontSize: 10,
    fontWeight: 400,
    color: colors.text,
  },
  contentContainer: {
    flex: 1,
  },
  commentTitle: {
    fontSize: 10,
    fontWeight: 400,
    color: colors.text,
  },
  commentExample: {
    fontSize: 9,
    fontWeight: 400,
    color: colors.textMuted,
  },
  commentsRow: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    gap: 24,
    alignItems: "flex-start",
  },
  commentsColumn: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  reviewsCommentsImageContainer: {
    width: 250,
    height: 200,
    alignSelf: "center",
  },
  reviewsTimelineContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
});
